module.exports = __webpack_public_path__ + "media/common/images/hirelocalelectricians.com.au/image2-6c9bd72853c2eec3188ea8da9df87534.png";